import moment from 'moment';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';


import Unibox from './unibox';
import AllEmails from './allEmails';
import './index.css';
import TitleRoute from '../../components/titleRoute.js';

const initialCreate = {
  name: '',
  assistantId: '',
  createdBy: localStorage.getItem('userId') || '',
  phoneNumber: [],
  callsInterval: '',
  intervalTime: '',

};

// Dropdown options
const optionsData = [
  { value: "RemoteJobLab", label: "Remote Job Lab" },
  { value: "CreateWorkspace", label: "Create Workspace", icon: <><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M5 12H19" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
];


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));



const EmailAccounts = (props) => {

  const dispatch = useDispatch();
  const [newValue, setValue] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [editState, setEditState] = useState(initialCreate);
  const [createState, setCreateState] = useState(initialCreate);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [scheduledDate, setScheduledDate] = useState(new Date());


  const handleTabsSet = (event, newValue) => {
    setValue(newValue);
  };

  return (

    <div className='content'>
      <div className='main-container'>
        <div className='page-title-area'>
          <TitleRoute />
          {/* <div className='right-btn-area'>
            <button className='btn-style-new'>+ Add Deal</button>
            <button className='btn-style-border'>+ Import Deal</button>
          </div> */}
        </div>
        <div className='bottom-content-area'>
          <div className='tabs-box'>
            <div className='tabs-email'>
              <AppBar position="static">
                <Tabs value={newValue} onChange={handleTabsSet} aria-label="simple tabs example">
                  <Tab label="All Emails" />
                  <Tab label="UniBox" />
                </Tabs>
              </AppBar>

            </div>
          </div>

          <div className='tabs-content'>
            <TabPanel value={value} index={0}>
              <AllEmails />
            </TabPanel>

            <TabPanel value={value} index={1}>
              <Unibox />
            </TabPanel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailAccounts;

